export default `
mutation produto(
    $tagEmMaos: Boolean
    $idProposta: String
    $tipoProduto: String
    $captchaResponse: String
  ) {
    produtoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse
        pedido: {
          produtos: [{ tagEmMaos: $tagEmMaos, tipoProduto: $tipoProduto }]
        }
      }
    ) {
      dados {
        id
        situacaoProposta
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
